import React from "react";

export default function WhyTokenize() {
  return (
    <>
      <section className="glance-section centred py_100">
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              <div
                className="pattern-1"
                style={{
                  backgroundImage: "url(assets/images/shape/shape-5.png)",
                }}
              />
              <div
                className="pattern-2"
                style={{
                  backgroundImage: "url(assets/images/shape/shape-6.png)",
                }}
              />
              <div
                className="pattern-3 rotate-me"
                style={{
                  backgroundImage: "url(assets/images/shape/shape-7.png)",
                }}
              />
              <div
                className="pattern-4 rotate-me"
                style={{
                  backgroundImage: "url(assets/images/shape/shape-8.png)",
                }}
              />
              <div
                className="pattern-5 rotate-me"
                style={{
                  backgroundImage: "url(assets/images/shape/shape-9.png)",
                }}
              />
            </div>
            <div className="sec-title light mb_80">
              <h2>Why Tokenize Assets with Xeer Technology?</h2>
              <p>
                Tokenization has revolutionized ownership, providing fractional
                ownership of tangible assets like real estate, art, commodities,
                and even intellectual property. By leveraging blockchain, we
                enable a cost-effective, secure, and accessible way for
                individuals and institutions to invest in high-value assets.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
